<script>

    export let id;
    export let text;
</script>

<div>
    <slot />
    <label for={id}>{text}</label>
</div>
<style>div {
    display: flex;
    align-items: center;
}
label {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 0.2em;
}
</style>